/* Suprafeel · /pages/contacto — behaviour ported from src/routes/contacto-wf (CtPuertas, CtForm, CtFaq, bus.ts).
   Loaded by several sections; runs once. */
(function () {
  if (window.__sfwCt) return;
  window.__sfwCt = true;

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function formParts() {
    var root = document.querySelector('[data-sfw-ct-form]');
    if (!root) return null;
    return {
      root: root,
      form: root.querySelector('form'),
      thanks: root.querySelector('[data-sfw-ct-thanks]'),
      fields: root.querySelector('[data-sfw-ct-fields]'),
      select: root.querySelector('#sfw-ct-origen')
    };
  }

  function setError(key, on) {
    var wrap = document.querySelector('[data-sfw-ct-field="' + key + '"]');
    if (!wrap) return;
    var ctl = wrap.querySelector('input, textarea, select');
    var msg = document.getElementById('sfw-ct-' + key + '-err');
    wrap.classList.toggle('is-error', !!on);
    if (msg) msg.hidden = !on;
    if (ctl) {
      if (on) {
        ctl.setAttribute('aria-invalid', 'true');
        if (msg) ctl.setAttribute('aria-describedby', msg.id);
      } else {
        ctl.removeAttribute('aria-invalid');
        ctl.removeAttribute('aria-describedby');
      }
    }
  }

  function showForm(p) {
    if (p.thanks) p.thanks.hidden = true;
    if (p.fields) p.fields.hidden = false;
  }

  /* Door cards → form: preselect "¿Desde dónde escribes?" and scroll to the form (bus.ts goToForm). */
  function goToForm(origen) {
    var p = formParts();
    if (!p) return;
    showForm(p);
    if (p.select) {
      for (var i = 0; i < p.select.options.length; i++) {
        if (p.select.options[i].getAttribute('data-origen') === origen) {
          p.select.selectedIndex = i;
          break;
        }
      }
    }
    p.root.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function initForm() {
    var p = formParts();
    if (!p || !p.form) return;
    var form = p.form;
    form.noValidate = true;
    var ctl = {
      nombre: form.querySelector('#sfw-ct-nombre'),
      email: form.querySelector('#sfw-ct-email'),
      mensaje: form.querySelector('#sfw-ct-mensaje'),
      privacidad: form.querySelector('#sfw-ct-privacidad')
    };

    Object.keys(ctl).forEach(function (k) {
      var el = ctl[k];
      if (!el) return;
      el.addEventListener(k === 'privacidad' ? 'change' : 'input', function () { setError(k, false); });
    });

    form.addEventListener('submit', function (e) {
      var bad = {
        nombre: ctl.nombre && !ctl.nombre.value.trim(),
        email: ctl.email && !EMAIL_RE.test(ctl.email.value.trim()),
        mensaje: ctl.mensaje && !ctl.mensaje.value.trim(),
        privacidad: ctl.privacidad && !ctl.privacidad.checked
      };
      var first = null;
      Object.keys(bad).forEach(function (k) {
        setError(k, bad[k]);
        if (bad[k] && !first) first = k;
      });
      if (first) {
        e.preventDefault();
        ctl[first].focus();
      }
    });

    var again = p.root.querySelector('[data-sfw-ct-again]');
    if (again) {
      again.addEventListener('click', function (e) {
        e.preventDefault();
        var keep = p.select ? p.select.selectedIndex : 0;
        form.reset();
        ['nombre', 'email', 'mensaje'].forEach(function (k) { if (ctl[k]) ctl[k].value = ''; });
        if (p.select) p.select.selectedIndex = keep;
        ['nombre', 'email', 'mensaje', 'privacidad'].forEach(function (k) { setError(k, false); });
        showForm(p);
      });
    }
  }

  function initDoors() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[data-sfw-ct-origen]');
      if (!a || !formParts()) return;
      e.preventDefault();
      goToForm(a.getAttribute('data-sfw-ct-origen'));
    });
  }

  /* FAQ: each row toggles independently (CtFaq). */
  function initFaq() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('.sfw-ct-faq__btn');
      if (!btn) return;
      var item = btn.closest('.sfw-ct-faq__item');
      var open = !item.classList.contains('is-open');
      item.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      var clip = item.querySelector('.sfw-ct-faq__clip');
      if (clip) {
        if (open) clip.removeAttribute('inert');
        else clip.setAttribute('inert', '');
      }
    });
  }

  function init() {
    initForm();
    initDoors();
    initFaq();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', function () { initForm(); });
})();
